import { Box, Divider, List, ListItemButton, ListItemIcon, ListSubheader, Paper, styled, } from '@mui/material';
export const MenuPaper = styled(Paper)(() => ({
    minWidth: 230,
    maxWidth: 230,
    maxHeight: 320,
    overflowY: 'auto',
    borderRadius: 12,
    overflow: 'hidden',
}));
export const MenuList = styled(List)(() => ({
    paddingTop: '0.2rem',
    paddingBottom: '0.2rem',
    overflowY: 'auto',
    maxHeight: 320,
    '&::-webkit-scrollbar': {
        display: 'none',
    },
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
}));
export const MenuListSubheader = styled(ListSubheader)(({ theme }) => ({
    lineHeight: 1.4,
    typography: 'overline',
    color: theme.palette.text.secondary,
    backgroundColor: 'transparent',
    paddingTop: '0.2rem',
    '&.MuiListSubheader-root': {
        fontSize: (theme) => theme.typography.overline.fontSize,
        lineHeight: 2.5,
    },
}));
export const MenuListItemButton = styled(ListItemButton)(({ theme }) => ({
    alignItems: 'center',
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    gap: 6,
}));
export const MenuListItemIcon = styled(ListItemIcon, {
    shouldForwardProp: (prop) => prop !== 'isSelected',
})(({ isSelected, theme }) => ({
    minWidth: 0,
    marginRight: '0.2rem',
    display: 'flex',
    alignItems: 'stretch',
    color: isSelected ? theme.palette.primary.main : theme.palette.text.secondary,
}));
export const IconContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    backgroundColor: theme.palette.action.hover,
    paddingLeft: 8,
    paddingRight: 8,
    minWidth: '1.8rem',
    minHeight: '1.8rem',
    color: 'inherit',
}));
export const PrefixLabelBox = styled(Box)(() => ({
    fontSize: '0.6rem',
    fontWeight: 700,
    letterSpacing: '0.05em',
    color: 'inherit',
}));
export const MenuDivider = styled(Divider)(() => ({
    opacity: 0.4,
    marginTop: '0.5rem',
    marginBottom: '0rem',
}));
